<tax-price>

    <span>
        { (props.unit_char === "¥") ? "¥" : ""}<number-format
            number={props.tax_price}/>{ (props.unit_char !== "¥") ? "円" : ""}
    </span>


    <script>
        export default {};
    </script>

</tax-price>